import React, { useState, useEffect } from "react";
import { BaseUrl, VoiceDomainName } from "../../Container/BaseUrl/BaseUrl";
import {
  Button,
  Pagination,
  Typography,
  Stack,
  ButtonGroup,
  Box,
  IconButton,
  Drawer,
} from "@mui/material";
import { toast } from "react-toastify";
import axios from "axios";
import { connect } from "react-redux";
import { setDialedNumberInc } from "../../Redux/Actions/actions";
import { ArrowCounterClockwise, PhoneOutgoing } from "@phosphor-icons/react";
import { Hourglass } from "react-loader-spinner";
import {
  StyledPaper,
  StyledTableContainer,
  StyledTable,
  StyledTableHead,
  StyledTableBody,
  StyledTableRow,
  StyledTableCell,
  StyledTableCell2,
} from "../../CustomComponent/TableCompoent";
import { toaststyle } from "../../Utils/toaststyle";
import { DownloadSimple, FunnelSimple } from "@phosphor-icons/react";
import Nodata from "../../Assets/images/svg/Data-unavailable.svg";

const mapStateToProps = (state) => {
  return {
    skillset: state.data.skillset,
    showingStatusVoice: state.contactListData.showingStatusVoice,
  };
};

const MakeCall = (props) => {
  let loggedInAgent = JSON.parse(localStorage.getItem("tokenAgent"));

  var someDate = new Date();
  var date = someDate.setDate(someDate.getDate());
  var defaultValue = new Date(date).toISOString().split("T")[0];

  const isToDateValid = () => {
    return new Date(todate) >= new Date(fromdate);
  };

  const [fromdate, setFromdate] = useState('');
  const [todate, setTodate] = useState('');
  const [getTransferDate, setgetTransferDate] = useState();
  const [showfilter, setshowfilter] = useState(false);
  const [status, setstatus] = useState("");
  const [missedCallList, setmissedCallList] = useState([]);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState(0);
  const [spinner, setspinner] = useState(false);
  const [openDialog, setopenDialog] = useState(false);
  const [sourceAgents, setsourceAgents] = useState("");
  const [DestinationAgents, setDestinationAgents] = useState("");

  const [selectedCalls, setselectedCalls] = useState();
  const [totalcalls, settotalcalls] = useState(0);

  const handleChange = (event, value) => {
    setPage(value);
    if (loggedInAgent.role == "Supervisor") {
      MissedCallsAPiSupervisor();
    } else {
      MissedCallsAPi();
    }
  };

  const MissedCallsAPi = (value) => {
    if (!value) {
      setspinner(true);
    }
    axios
      .post(
        BaseUrl + "/contact/listCampaignDetails",
        {
          from_date: fromdate,
          to_date: todate,
          agent_id: loggedInAgent.agent_id,
          limit: 10,
          offset: page == 1 ? 0 : (page - 1) * 10,
          type: status,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        setspinner(true);
        if (res.data.status) {
          setmissedCallList(res.data.data);
          settotalcalls(res.data.count);
          setPagination(res.data.count);
          setTimeout(() => {
            setspinner(false);
          }, 1500);
        } else {
          setmissedCallList([]);
          settotalcalls(0);
          setPagination(0);
          setTimeout(() => {
            setspinner(false);
          }, 1500);
        }
      })
      .catch((err) => {
        setTimeout(() => {
          setspinner(false);
        }, 1500);
      });
  };
  const MissedCallsAPiSupervisor = (value) => {
    if (!value) {
      setspinner(true);
    }
    axios
      .post(
        BaseUrl + "/contact/listCampaignDetailssupervisor",
        {
          from_date: fromdate,
          to_date: todate,
          agent_id: "",
          limit: 10,
          offset: page == 1 ? 0 : (page - 1) * 10,
          type: status,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        setspinner(true);
        if (res.data.status) {
          setmissedCallList(res.data.data);
          settotalcalls(res.data.count);
          setPagination(res.data.count);
          setTimeout(() => {
            setspinner(false);
          }, 1500);
        } else {
          setmissedCallList([]);
          settotalcalls(0);
          setPagination(0);
          setTimeout(() => {
            setspinner(false);
          }, 1500);
        }
      })
      .catch((err) => {
        setTimeout(() => {
          setspinner(false);
        }, 1500);
      });
  };

  //   useEffect(() => {
  //     const intervalId = setInterval(() => {
  //       if (loggedInAgent.role == "Supervisor") {
  //         MissedCallsAPiSupervisor("noSpinner");
  //       } else {
  //         MissedCallsAPi("noSpinner");
  //       }
  //     }, 60000);
  //     return () => clearInterval(intervalId);
  //   }, []);

  useEffect(() => {
    MissedCallsAPi();
  }, [page]);

  const handleCloseDialogBox = () => {
    setopenDialog(false);
  };

  const handleChangeCount = (event) => {
    setselectedCalls(event.target.value);
  };

  const transfer = async () => {
    await axios
      .post(
        BaseUrl + "/contact/updatecampaignDetailsagent",
        {
          source_id: sourceAgents,
          destination_id: DestinationAgents,
          count: selectedCalls,
          date: getTransferDate,
          type: "Abandoned",
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          setopenDialog(false);
          MissedCallsAPiSupervisor();
          toast.warn(res.data.message, toaststyle);
        } else {
          setopenDialog(false);
          MissedCallsAPiSupervisor();
          toast.warn(res.data.message, toaststyle);
        }
      })
      .catch((err) => {
        setShow(true);
      });
  };

  const makeCall = (calledNo, value2) => {
    let number = `9${calledNo}`;
    if (props.showingStatusVoice == "Ready") {
      localStorage.setItem("callActivate", "true");
      localStorage.setItem("CallMadeFromDcc", "true");
      localStorage.setItem("callDirectionType", "MC_Outbound");
      let agentLoginTerminalId = localStorage.getItem("agentLoginTerminalId");
      let avcurlid = localStorage.getItem("AvcUrl");
      props.setDialedNumberInc(number);
      localStorage.setItem("ClickeToCallPhoneNum", number);
      localStorage.setItem("dailedNumber", number);
      localStorage.setItem("ClickToCall", "true");
      localStorage.setItem("clickToCallCallerID", value2);

      axios
        .post(
          avcurlid +
          `/voice/terminal/${agentLoginTerminalId}/createContact/sip:${agentLoginTerminalId}@${VoiceDomainName}/sip:${number}@${VoiceDomainName}`,
          {},
          {
            headers: {
              ssoToken: localStorage.getItem("ssoToken"),
            },
          }
        )
        .then((res) => {
          if (res.data.status == "OK") {
            localStorage.setItem("misserCallClicktoCall", value2);
          } else {
            toast.warn(res.data.status, toaststyle);
          }
        })
        .catch((err) => {
          if (err.code == "ERR_BAD_REQUEST") {
            toast.error("Please change status to Ready", toaststyle);
          }
        });
    } else {
      toast.error("Please change status to Ready", toaststyle);
    }
  };

  const convertDateTime = (date) => {
    if (!date) return;
    return new Date(date).toISOString().replace("T", " ").substring(0, 19);
  };

  return (
    // Abandoned Calls start here 
    <StyledPaper>
      <div className="card Report-card w-100 border-0">
        {/* card-header  */}
        <div
          className="card-header border-0 d-flex align-items-center justify-content-between px-2"
          sx={{ fontWeight: 600, color: "#1473e6" }}
        >
          <div
            className="fw-bold fs-16"
            style={{
              textShadow: "1px 0px 0px #c2c2c27d",
              color: "#0b3363",
            }}
          >
            Abandoned Calls
          </div>
          <div>
            <ButtonGroup
              variant="contained"
              aria-label="button group"
              disableElevation
              size="small"
              sx={{
                textTransform: "capitalize",
              }}
            >

              {/* Refresh btn  */}
              <Button
                sx={{
                  textTransform: "capitalize",
                }}
                onClick={() => {
                  MissedCallsAPi();
                  setspinner("rotate 1s infinite");
                }}
              >
                <ArrowCounterClockwise className="me-2"
                  style={{ animation: spinner }}
                />
                Refresh
              </Button>
              {/* Filter btn  */}
              <Button
                sx={{
                  textTransform: "capitalize",
                }}
                onClick={() => {
                  setshowfilter(true);
                }}
              >
                <FunnelSimple className="me-2" />
                Filter
              </Button>
            </ButtonGroup>
          </div>
        </div>
        {/* card-body */}
        <div
          className="card-body p-1 vh-71 box-inset"
          sx={{
            justifyContent: "center",
            display: "flex",
            height: "calc(100% - 40px)",
            display: "flex",
            flexDirection: "column",
            gap: "10",
          }}
        >
          <Box>
            <StyledTableContainer sx={{ height: "26rem !important" }}>
              <StyledTable stickyHeader aria-label="sticky table" size="small">
                <>
                  <StyledTableHead>
                    <StyledTableRow>
                      {[
                        "Action",
                        "Phone Number",
                        "SkillSet",
                        "CreatedDate",
                        "OriginatedStamp",
                        "Retry Count",
                        "Call Status",
                        
                      ].map((headers) => (
                        <StyledTableCell style={{ minWidth: "150px" }}>
                          {headers}
                        </StyledTableCell>
                      ))}
                    </StyledTableRow>
                  </StyledTableHead>
                  <StyledTableBody>
                    {spinner ? (
                      <Stack sx={{ position: "absolute", top: "50%", left: "50%" }}>
                        <Hourglass
                          visible={true}
                          height="30"
                          width="30"
                          ariaLabel="hourglass-loading"
                          wrapperStyle={{}}
                          wrapperClass=""
                          colors={["#2268a0", "#72a1ed"]}
                        />
                      </Stack>
                    ) : missedCallList.length > 0 ? (
                      missedCallList.map((item) => {
                        return (
                          <StyledTableRow hover role="checkbox" tabIndex={-1}>
                          <StyledTableCell2>
                              <IconButton
                                onClick={() => {
                                  makeCall(item.Originator, item.id);
                                }}
                              >
                                <PhoneOutgoing size={22} weight="bold" />
                              </IconButton>
                            </StyledTableCell2>
                            <StyledTableCell2>{item.Originator}</StyledTableCell2>
                            <StyledTableCell2>{item.SkillSet}</StyledTableCell2>
                            <StyledTableCell2>
                              {convertDateTime(item.CreatedDate)}
                            </StyledTableCell2>
                            <StyledTableCell2>
                              {convertDateTime(item.OriginatedStamp)}
                            </StyledTableCell2>
                            <StyledTableCell2>
                              {item.callcount ? item.callcount : 0}
                            </StyledTableCell2>
                            <StyledTableCell2>
                              {item.callstatus ? item.callstatus : "NA"}
                            </StyledTableCell2>
                           
                          </StyledTableRow>
                        );
                      })
                    ) : (
                      // Data unavailable start
                      <Stack
                        sx={{
                          position: "absolute",
                          width: "100%",
                          height: "calc(100vh - 14rem)",
                        }}
                        justifyContent="center"
                        alignContent="center"
                      >
                        <Stack
                          className="text-muted"
                          direction="column"
                          justifyContent="center"
                          alignContent="center"
                        >
                          <span className="mx-auto">
                            <img
                              src={Nodata}
                              alt="pic"
                              style={{ width: "11rem", userSelect: "none" }}
                            />
                          </span>
                          <span className="mx-auto">
                            <h6
                              className="text-muted mt-3"
                              style={{ fontSize: "13px" }}
                            >
                              Data unavailable
                            </h6>
                          </span>
                        </Stack>
                      </Stack>
                      // Data unavailable end
                    )}
                  </StyledTableBody>
                </>
              </StyledTable>
            </StyledTableContainer>
          </Box>
        </div>
        {/* card-footer */}
        <div className="card-footer border-0">
          <Box>
            <Stack
              sx={{ width: "100%", height: "100%" }}
              direction={"row"}
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              {/* Pagination content  */}
              <Typography variant="caption" sx={{ fontSize: "12px" }}>
                Showing {Math.min((page - 1) * 10 + 1, pagination)} to{" "}
                {Math.min(page * 10, pagination)} of {pagination} entries
              </Typography>
              {/* Pagination  */}
              <Pagination
                count={Math.ceil(pagination / 10)}
                page={page}
                shape="rounded"
                color="primary"
                size="small"
                style={{ float: "right" }}
                onChange={handleChange}
              />
            </Stack>
          </Box>
        </div>
      </div>

      {/* Filters Drawer Start  */}
      <Drawer
        anchor="right"
        open={showfilter}
        onClose={() => {
          setshowfilter(false);
        }}
      >
        <Box style={{ width: "20rem" }}>
          {/* Drawer head start */}
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            className="p-3 shadowDrawer"
          >
            <Typography variant="h3" gutterBottom className="drawer-title">
              Filters
            </Typography>
          </Stack>
          {/* Drawer head end */}
          {/* Drawer Content start */}
          <Stack
            className="p-3"
            style={{ height: "calc(100vh - 7rem)", overflowY: "scroll" }}
          >
            <form className="fs-13">

              <div className="mb-3 d-flex flex-column text-start">
                <label htmlFor="fromdate" className="form-label">
                  From
                </label>
                <input
                  type="date"
                  className="form-control"
                  id=""
                  aria-describedby="date"
                  value={fromdate}
                  onChange={(e) => setFromdate(e.target.value)}
                  max={defaultValue}
                />
              </div>
              <div className="mb-3 d-flex flex-column text-start">
                <label htmlFor="todate" className="form-label">
                  To
                </label>
                <input
                  type="date"
                  className="form-control"
                  id=""
                  aria-describedby="date"
                  value={todate}
                  onChange={(e) => setTodate(e.target.value)}
                  max={defaultValue}
                />
                {!isToDateValid() && (
                  <span
                    className="text-danger fw-bold"
                    style={{ fontSize: "10px" }}
                  >
                    To Date cannot be less than From Date*
                  </span>
                )}
              </div>

            </form>
          </Stack>
          {/* Drawer Content end */}
          {/* Drawer footer start */}
          <Stack
            className="p-2"
            sx={{
              position: "absolute",
              bottom: "0",
              background: "#f9f9f9",
              width: "100%",
              boxShadow:
                "rgba(14, 63, 126, 0.04) 0px 0px 0px 1px, rgba(42, 51, 69, 0.04) 0px 1px 1px -0.5px, rgba(42, 51, 70, 0.04) 0px 3px 3px -1.5px, rgba(42, 51, 70, 0.04) 0px 6px 6px -3px, rgba(14, 63, 126, 0.04) 0px 12px 12px -6px, rgba(14, 63, 126, 0.04) 0px 24px 24px -12px",
            }}
            direction="row"
            justifyContent="space-between"
            alignContent="center"
          >
            <Button
              variant="contained"
              className="me-2 w-100"
              sx={{
                textShadow: "0 1px 0 rgba(0, 0, 0, .4)",
                textTransform: "Capitalize",
              }}
              color="error"
              disableElevation
              onClick={() => {
                setshowfilter(false);
              }}
            >
              Close
            </Button>
            <Button
              className="w-100"
              variant="contained"
              disableElevation
              sx={{
                textShadow: "0 1px 0 rgba(0, 0, 0, .4)",
                textTransform: "Capitalize",
              }}
              id="session_filter_Submit"
              onClick={() => {
                if (isToDateValid()) {
                  MissedCallsAPi();
                  setPage(1);
                  setshowfilter(false);
                }
              }}
            >
              Submit
            </Button>
          </Stack>
          {/* Drawer footer end */}
        </Box>
      </Drawer>
      {/* Filters Drawer end  */}
    </StyledPaper>
    // Abandoned Calls end here 
  );
};

export default connect(mapStateToProps, { setDialedNumberInc })(MakeCall);
